import styled from "styled-components";

export const StyledSSOButton = styled.button<{
  backgroundColor: string;
  hoverBackgroundColor: string;
  activeBackgroundColor: string;
  color: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: 2px solid ${({ backgroundColor }) => backgroundColor};
  border-bottom: none;

  color: ${({ color }) => color};
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.5s ease;
  position: relative;
  &:hover {
    background-color: ${({ hoverBackgroundColor }) => hoverBackgroundColor};
    border: 2px solid ${({ hoverBackgroundColor }) => hoverBackgroundColor};
    border-bottom: none;
  }
  &:active {
    background-color: ${({ activeBackgroundColor }) => activeBackgroundColor};
    border: 2px solid ${({ activeBackgroundColor }) => activeBackgroundColor};
    border-bottom: none;
  }
  p {
    margin: 0;
  }
  img {
    display: block;
    position: absolute;
    background-color: #fff;
    padding: 10px;
    top: 0;
    left: 0;
    bottom: 0;
    width: 18px;
    height: 18px;
  }
`;
